module.exports = __webpack_public_path__ + "img/deep_sleep-icon-1.4efa5b10.svg";